import { CompanyData } from './../../../types/constants';

import bg from './../../../assets/img/core_illumination_bg.jpg';
import { projects } from './../core-illumination/projects';

export const coreIllumination: CompanyData = {
  id: 2,
  name: 'Core Illumination Pty Ltd',
  country: 'Australia',
  bg: bg,
  position: 'Software Engineer (Internship)',
  time: 'Mar 2021 - May 2021 (12 Weeks)',
  description:
    'It is a software development company based in Brisbane, Australia. I got the opportunity to work with them under the internship program of my master’s degree',
  projects: projects,
};
